export default __webpack_public_path__ + "static/media/log-out.46baff53.svg";